'use strict';

const $ = jQuery.noConflict();
$(function() {
	const hero = {
		interval: null,
		currentIndex: 0,
		DELAY: 6000,

		init: function() {
			this.cacheDOM();

			if (this.$slides.length < 2) {
				return;
			}

			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
				return;
			}

			this.startCrossfade();
			// this.bindEvents();
		},

		cacheDOM: function() {
			this.$slides = $('.js-hero-slide');
			this.$hero = this.$slides.closest('.hero');
		},

		// bindEvents: function() {
		// 	this.$hero.on('mouseenter', this.stopCrossfade.bind(this));
		// 	this.$hero.on('mouseleave', this.startCrossfade.bind(this));
		// },

		startCrossfade: function() {
			this.stopCrossfade();
			this.interval = setInterval(this.nextSlide.bind(this), this.DELAY);
		},

		stopCrossfade: function() {
			if (this.interval) {
				clearInterval(this.interval);
				this.interval = null;
			}
		},

		nextSlide: function() {
			const $current = this.$slides.eq(this.currentIndex);
			this.currentIndex = (this.currentIndex + 1) % this.$slides.length;
			const $next = this.$slides.eq(this.currentIndex);

			$current.removeClass('is-active');
			$next.addClass('is-active');
		},
	};

	hero.init();
});
